<template>
  <v-row>
    <v-col cols="12" v-for="(schedule, i) in resource.schedules" :key="i">
      <v-card
        outlined
        :to="
          schedule.sentDate
            ? `/reporting/training/overview/training/${resource.id}/sends/${schedule.id}`
            : null
        "
      >
        <v-container class="py-0">
          <v-row dense>
            <v-col
              :cols="$vuetify.breakpoint.mdAndUp ? 'auto' : '12'"
              class="my-auto"
            >
              <v-chip small :color="chipColor(schedule)"
                >{{ chipText(schedule) }}
              </v-chip>
            </v-col>
            <v-col class="my-auto">
              {{ lineText(schedule) }}
            </v-col>
            <v-spacer></v-spacer>
            <v-col v-if="schedule.sentDate != null" class="my-auto">
              <simple-engagement-text
                :engagement="schedule.userRecords"
              ></simple-engagement-text>
            </v-col>
            <v-col cols="auto">
              <v-menu absolute>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" v-on:click.prevent icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-if="schedule.sentDate == null && schedule.canSave"
                    @click="$emit('edit', schedule.id)"
                  >
                    <v-list-item-title>Edit Schedule</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="schedule.sentDate != null"
                    :to="
                      `/reporting/training/overview/training/${resource.id}/sends/${schedule.id}`
                    "
                  >
                    <v-list-item-title>View Report</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    v-if="schedule.sentDate == null && schedule.canSave"
                    @click.prevent="$emit('delete', schedule.id)"
                  >
                    <v-list-item-title>Delete</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import dateFilter from "@/helpers/filters/date";
import SimpleEngagementText from "@/components/reporting/SimpleEngagementText";
export default {
  name: "ResourceCardSchedules",
  components: { SimpleEngagementText },
  props: { resource: { type: Object } },
  data: () => ({ loading: false }),
  computed: {
    chipColor() {
      return schedule => {
        if (schedule.sentDate != null) {
          return "success";
        }
        return "primary";
      };
    },
    chipText() {
      return schedule => {
        if (schedule.sentDate != null) {
          return "Sent";
        }
        return "Scheduled";
      };
    },
    lineText() {
      return schedule => {
        if (schedule.sentDate != null) {
          return `Sent on ${dateFilter.longDateWithTime(schedule.sentDate)}`;
        }
        return `Scheduled for ${dateFilter.longDateWithTime(
          schedule.sendDate
        )}`;
      };
    },
    ...mapGetters({})
  },
  mounted() {
    if ((this.resource.schedules || []).length > 0) {
      return;
    }
    this.loadSchedules();
  },
  methods: {
    loadSchedules() {
      this.loading = true;
      this.$store
        .dispatch("resource/getResourceSchedules", this.resource.id)
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading resource schedules."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
